import type {
  BankOfferMetrics,
  BusinessUnitClientsMetrics,
  BusinessUnitLeadMetrics,
  BusinessUnitMessagesMetrics,
  BusinessUnitResponseTimesMetrics,
  GetBusinessUnitMetricsParams,
} from '../types/metrics';
import baseWorkloadApi from './baseWorkloadApi';

const insightsApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getClientsMetrics: build.mutation({
      query: (params: GetBusinessUnitMetricsParams) => ({
        url: '/insights/clients',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: BusinessUnitClientsMetrics): BusinessUnitClientsMetrics => response,
    }),
    getMessagesMetrics: build.mutation({
      query: (params: GetBusinessUnitMetricsParams) => ({
        url: '/insights/messages',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: BusinessUnitMessagesMetrics): BusinessUnitMessagesMetrics => response,
    }),
    getResponseTimesMetrics: build.mutation({
      query: (params: GetBusinessUnitMetricsParams) => ({
        url: '/insights/response-times',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: BusinessUnitResponseTimesMetrics): BusinessUnitResponseTimesMetrics => response,
    }),
    getConversationMetrics: build.mutation({
      query: (props: GetBusinessUnitMetricsParams) => ({
        url: '/insights/conversations-metrics',
        method: 'POST',
        body: props,
      }),
      transformResponse: (response: { topics: Record<string, number>; endReasons: Record<string, number> }) => response,
    }),
    getLeadMetrics: build.mutation({
      query: (params: GetBusinessUnitMetricsParams) => ({
        url: '/insights/leads',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: BusinessUnitLeadMetrics): BusinessUnitLeadMetrics => response,
    }),
    getBankOfferMetrics: build.mutation({
      query: (params: GetBusinessUnitMetricsParams) => ({
        url: '/insights/bank-offers',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: BankOfferMetrics): BankOfferMetrics => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetClientsMetricsMutation,
  useGetMessagesMetricsMutation,
  useGetResponseTimesMetricsMutation,
  useGetConversationMetricsMutation,
  useGetLeadMetricsMutation,
  useGetBankOfferMetricsMutation,
} = insightsApi;
